import { Heading } from '@cue/atoms';
import { useTranslation } from 'react-i18next';

export const ComingSoon: React.FC = () => {
  const { t } = useTranslation();
  return (
    <div className="cue-project-coming-soon">
      <div className="cue-project-coming-soon-text-content">
        <Heading type="h4">{t('comingsoon.header-1')}</Heading>
        <Heading type="h4" className="light roman ">
          {t('comingsoon.header-2')}
        </Heading>
      </div>
    </div>
  );
};
